import React from 'react';
import './ProtectYourself.css';

const tips = [
  {
    icon: '🔍',
    title: 'Vérifiez l\'URL AVANT de payer',
    desc: 'Avant toute saisie de CB, regardez la barre d\'adresse. Le domaine doit correspondre exactement au vendeur. Une redirection = danger.',
  },
  {
    icon: '🛡️',
    title: 'Utilisez une carte virtuelle',
    desc: 'Services comme Revolut, Lydia ou N26 proposent des cartes virtuelles à usage unique. Idéal pour les achats sur des sites inconnus.',
  },
  {
    icon: '📜',
    title: 'Lisez les CGV (vraiment)',
    desc: 'Cherchez les mots "abonnement", "renouvellement", "mensuel". S\'ils sont présents, cherchez activement la case pour refuser.',
  },
  {
    icon: '🏪',
    title: 'Achetez sur des plateformes connues',
    desc: 'TikTok Shop officiel, Amazon, Cdiscount — préférez les marketplaces avec protection acheteur garantie plutôt que des sites inconnus.',
  },
  {
    icon: '🔔',
    title: 'Activez les alertes SMS de votre banque',
    desc: 'Chaque prélèvement vous alerte en temps réel. Vous pouvez réagir immédiatement au lieu de découvrir le problème sur votre relevé.',
  },
  {
    icon: '🌐',
    title: 'Vérifiez l\'âge du domaine',
    desc: 'Sur whois.domaintools.com, cherchez la date de création du domaine. Un site créé il y a moins de 6 mois et vendant des produits = méfiance.',
  },
];

export default function ProtectYourself() {
  return (
    <section className="protect section" id="se-proteger" aria-labelledby="protect-title">
      <div className="container">
        <span className="tag orange">Prévention</span>
        <h2 id="protect-title" className="section-title" style={{ color: 'white' }}>
          Comment Ne Plus <span style={{ color: 'var(--orange)' }}>Se Faire Piéger</span>
        </h2>
        <p className="section-subtitle">
          6 règles simples qui protègent contre 95% des arnaques en ligne du type JumpVendor.
        </p>

        <div className="protect__grid">
          {tips.map((tip, i) => (
            <div key={i} className="protect__card">
              <div className="protect__card-icon">{tip.icon}</div>
              <h3 className="protect__card-title">{tip.title}</h3>
              <p className="protect__card-desc">{tip.desc}</p>
            </div>
          ))}
        </div>

        <div className="protect__share">
          <h3>📢 Partagez pour protéger vos proches</h3>
          <p>Si cette page vous a été utile, partagez-la. Chaque partage peut éviter une nouvelle victime.</p>
          <div className="protect__share-btns">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https://jumpvendor.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="share-btn share-btn--fb"
            >
              Facebook
            </a>
            <a
              href="https://twitter.com/intent/tweet?text=ARNAQUE+JUMPVENDOR.COM+%E2%80%94+Site+frauduleux+confirm%C3%A9.+Des+centaines+de+victimes.+Lisez+et+partagez+:&url=https://jumpvendor.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="share-btn share-btn--tw"
            >
              Twitter / X
            </a>
            <button
              className="share-btn share-btn--copy"
              onClick={() => navigator.clipboard.writeText('https://jumpvendor.fr')}
            >
              📋 Copier le lien
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
